import styled from "styled-components";

export const Title = styled.h2`
  color: ${({ theme }) => theme.heading.color.secondary};
  font-size: 16px;
  font-weight: 700;
  width: 100%;
`;
